import {
  type ActionsHandlerData,
  type Notification,
  NotificationsEvents,
} from '@robovision/notifications'
import { LocalStorage } from 'quasar'
import { LocalStorageKeys } from '~domain/localStorageKeys'
import router from '~router'
import { notificationsApi } from '~services/api'
import { dataToNotification } from '../utils/notifications'


export async function notificationActionsHandler (data: ActionsHandlerData): Promise<Notification[] | void> {
  switch (data.event) {
    case NotificationsEvents.Action:
      if (data.action.callback) {
        void data.action.callback()
      } else if (data.action.to) {
        void router.push(data.action.to)
      }
      break
    case NotificationsEvents.DeleteAll:
      try {
        await notificationsApi.notifications.deleteAllNotifications()
      } catch (e) {
        console.error(e)
      }
      break

    case NotificationsEvents.Delete:
      try {
        await notificationsApi.notifications.deleteNotifications({
          eventIds: [data.id],
        } as never) // TODO should be fixed in the generated client
      } catch (e) {
        console.error(e)
      }
      break

    case NotificationsEvents.Load:
      try {
        const { data } = await notificationsApi.notifications.listNotifications()
        const notifications = await Promise.all(data.notifications.map(dataToNotification))

        return notifications
      } catch (e) {
        console.error(e)
      }
      break

    case NotificationsEvents.MarkAsRead:
      try {
        await notificationsApi.notifications.markNotificationsAsRead({
          eventIds: data.ids,
        } as never) // TODO should be fixed in the generated client
      } catch (e) {
        console.error(e)
      }
      break

    case NotificationsEvents.OptionsChanged:
      LocalStorage.set(LocalStorageKeys.ShowPopupNotifications, data.showPopupNotifications)
      break
  }
}
